import { IApplicationState } from '../../types/redux';

export function selectCrossLinks(state: IApplicationState) {
  return state.сrossLinks;
}
